import { render, staticRenderFns } from "./ClosingReasonsTable.vue?vue&type=template&id=006eab7e&scoped=true&"
import script from "./ClosingReasonsTable.vue?vue&type=script&lang=js&"
export * from "./ClosingReasonsTable.vue?vue&type=script&lang=js&"
import style0 from "./ClosingReasonsTable.vue?vue&type=style&index=0&id=006eab7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006eab7e",
  null
  
)

export default component.exports